<template lang="pug">
.quantity-picker
  template(v-if="!bookingProduct.isSegmentless")
    QuantityPickerPerSegment(
      :quantitiesPerClassification="bookingProduct.QuantitiesPerClassification",
      :disabled="disabled"
      :infoMessage="infoMessage"
      :disablePlus="maxQuantityLeftToBeAdded === 0"
      :maxQuantityLeftToBeAdded="maxQuantityLeftToBeAdded"
      :belongsToDeal="belongsToDeal"
      :isCrossSell="isCrossSell"
      )
  template(v-else)
    BriqInput(
      v-model.number="bookingProduct.ProductQuantity",
      type="number",
      step="1",
      min="1",
      :disabled="disabled"
      data-test-id="flat-quantity-input"
      )
</template>

<script>
import { pipe, values, sum } from 'ramda'
import QuantityPickerPerSegment from './QuantityPickerPerSegment.vue'
import { getQuantitiesPerSegmentForSplitProduct } from '@v/bookings/edit/util/bookingDealFunctions.js'

export default {
  name: 'BookingProductQuantityPicker',
  components: { QuantityPickerPerSegment },
  props: {
    bookingProduct: { type: Object, required: true },
    bookingDeal: { type: Object },
    disabled: Boolean,
    belongsToDeal: Boolean,
  },
  computed: {
    infoMessage() {
      return this.maxQuantityLeftToBeAdded === 0 ? 'Resource quantity limit reached' : null
    },
    maxQuantityLeftToBeAdded() {
      if (!this.bookingDeal) return null
      // only relevant for split products
      const splitProductSummedSegmentQuantities = getQuantitiesPerSegmentForSplitProduct(
        this.bookingDeal,
        this.bookingProduct,
      )
      const used = pipe(values, sum)(splitProductSummedSegmentQuantities)
      return this.bookingDeal.quantities.total - used
    },
    isCrossSell() {
      return this.bookingProduct.DealProductType === 'CrossSell'
    },
  },
}
</script>

<style scoped lang="stylus">
.quantity-picker
  position relative
  height 38px
</style>
